import classNames from 'classnames';
import {
  FlexContainer,
  InfoMessageBlock,
  LoadingPlaceholder,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useSavedProperties } from 'state';
import { PropertiesList } from '../../bricks';
import styles from './SearchSavedScreen.module.scss';

/**
 * SearchSavedScreen
 *
 * @return {JSX.Element}
 */
const SearchSavedScreen = ({ className }) => {
  const savedPropertiesCollection = useSavedProperties();
  const { data: dataState, isInitialized } = savedPropertiesCollection;

  return isInitialized ? (
    <FlexContainer
      className={classNames(
        styles.SearchSavedScreen,
        className,
        `${SearchSavedScreen.displayName}`
      )}
      column
      gap
    >
      {dataState.length ? (
        <PropertiesList data={dataState} />
      ) : (
        <InfoMessageBlock
          title="No Saved Properties"
          description="Any properties you save on your search will be saved here for safe keeping."
        />
      )}
    </FlexContainer>
  ) : (
    <LoadingPlaceholder spinner />
  );
};

SearchSavedScreen.displayName = 'SearchSavedScreen';

export default observer(SearchSavedScreen);
